<template>
  <div class="flex items-center gap-2 w-full">
    <div v-if="isSelect">
      <VanCheckbox
        :model-value="include?.includes(mail.id)"
        @click="clickMail"
      />
    </div>

    <div
      class="px-4 py-2 bg-base-200 rounded-2xl overflow-hidden font-[Cubic] w-full"
      @click="clickMail"
    >
      <!-- 顶部头像与发件人 -->
      <div
        class="flex items-center mb-2 gap-2 justify-between"
        v-if="
          type &&
          [MateMailType.Sent, MateMailType.Inbox, MateMailType.Draft].includes(
            type
          )
        "
      >
        <div class="flex items-center gap-2">
          <div class="w-6">
            <UserAvatar
              :mate="type === MateMailType.Inbox ? mail.sender : mail.recipient"
              @click.stop="
                clickMate(
                  type === MateMailType.Inbox ? mail.sender : mail.recipient
                )
              "
            />
          </div>
          <div class="font-semibold">
            {{
              type === MateMailType.Inbox
                ? $t("mail.letterFrom", {
                    name: mail.sender?.name ?? "该用户状态异常",
                  })
                : $t("mail.letterTo", {
                    name: mail.recipient?.name ?? "该用户状态异常",
                  })
            }}
            <!-- <div class="text-base-content/70">{{ $t("mail.letter") }}</div> -->
          </div>
        </div>

        <div class="text-success text-xs" v-if="mail.children?.length">
          已回复
        </div>
      </div>
      <!-- 时间 -->
      <div class="text-base-content/70 mt-2 mb-1">
        {{
          moment(mail.dtCreate)
            .tz("Asia/Shanghai")
            .format("YYYY年MM月DD日 HH:mm")
        }}
      </div>
      <!-- 标题 -->
      <div class="text-base-content/70 mb-1">
        {{ $t("mail.subject") }}: <span>{{ mail.subject }}</span>
      </div>
      <!-- 收件人 -->
      <div
        class="mb-2 flex items-center gap-2 justify-between"
        v-if="type && [MateMailType.Inbox].includes(type)"
      >
        <div class="flex items-center gap-2 flex-1">
          <span class="text-base-content/70">{{ $t("mail.to") }}:</span>
          <span
            class="text-primary line-clamp-1 flex-1"
            @click.stop="clickMate(mail.recipient)"
          >
            {{ mail.recipient?.name ?? "该用户状态异常" }}
          </span>
        </div>

        <button
          v-if="!showDetail"
          class="btn-ghost underline cursor-pointer"
          @click.stop="expanded = !expanded"
        >
          {{
            expanded
              ? $t("interactive.reviewPage.mail.collapse")
              : $t("interactive.reviewPage.mail.expand")
          }}
        </button>
      </div>
      <!-- 发件人 -->
      <div
        class="mb-2 flex items-center gap-2 justify-between"
        v-if="type && [MateMailType.Sent, MateMailType.Draft].includes(type)"
      >
        <div class="flex items-center gap-2 flex-1">
          <span class="text-base-content/70">{{ $t("mail.from") }}:</span>
          <span
            class="text-primary line-clamp-1 flex-1"
            @click.stop="clickMate(mail.sender)"
          >
            {{ mail.sender?.name ?? "该用户状态异常" }}
          </span>

          <button
            class="btn-ghost underline cursor-pointer"
            v-if="!showDetail"
            @click.stop="expanded = !expanded"
          >
            {{
              expanded
                ? $t("interactive.reviewPage.mail.collapse")
                : $t("interactive.reviewPage.mail.expand")
            }}
          </button>
        </div>
      </div>
      <!-- 正文 -->
      <div
        :class="[
          'prose prose-sm same-size whitespace-pre-line',
          showDetail || expanded ? '' : 'line-clamp-2',
        ]"
        v-html="mail.body"
      />

      <span v-if="mail.reviewer?.name" class="text-base-content/70 text-xs">
        该信件经由
        <span @click.stop="clickMate(mail.sender)" class="text-primary">
          {{ mail.sender?.name ?? "该用户状态异常" }}
        </span>
        的创作者
        <span @click.stop="clickMate(mail.reviewer)" class="text-primary">
          {{ mail.reviewer?.name ?? "该用户状态异常" }}
        </span>
        审核后寄出
      </span>

      <!-- 按钮 -->
      <div class="flex gap-3 mt-2 justify-between flex-wrap" v-if="!isSelect">
        <div class="flex gap-2">
          <audio-play
            v-if="mail.audioMedia"
            :mate-tone-id="mail.sender?.mateToneId!"
            :msg="mail.body"
            :url="mail.audioMedia.url"
            btn-class="btn-xs btn-outline"
          />
          <button
            class="btn btn-xs btn-outline"
            @click.stop="clickReply"
            v-if="type && [MateMailType.Inbox].includes(type)"
          >
            {{ $t(`Buttons.reply`) }}
          </button>

          <button
            class="btn btn-xs btn-outline"
            @click.stop="clickCreateSceneMemory"
          >
            +记忆
          </button>

          <button class="btn btn-xs btn-outline" @click.stop="clickInviteTask">
            {{ $t(`mission.inviteTask`) }}
          </button>
        </div>
        <div class="flex gap-2">
          <button
            class="btn btn-xs btn-ghost"
            @click.stop="showActionSheet = true"
          >
            <i class="iconify mingcute--more-1-line"></i>
          </button>
          <!-- <button
            class="btn btn-xs btn-outline"
            @click.stop="clickDelete"
            v-if="
              type && [MateMailType.Inbox, MateMailType.Draft].includes(type)
            "
          >
            {{ $t(`Buttons.delete`) }}
          </button>
          <button
            class="btn btn-xs btn-outline"
            @click.stop="clickViewMailList"
            v-if="
              (tabType !== MateMailType.Threadbox &&
                MateMailType.Inbox === type) ||
              (type && [MateMailType.Sent].includes(type) && showDetail)
            "
          >
            {{ $t("interactive.reviewPage.mail.viewRelatedMails") }}
          </button> -->
        </div>
      </div>

      <!-- 往来信件 -->
      <div v-if="showDetail && mail.children?.length && !isChild" class="mt-2">
        <div class="red-dot">附：相关信件</div>
        <div class="flex flex-col gap-2">
          <MateMailItem
            v-for="child in mail.children"
            :key="child.id"
            :mail="child"
            show-detail
            is-child
          />
        </div>
      </div>
    </div>
    <VanActionSheet
      v-model:show="showActionSheet"
      :actions="actions"
      close-on-click-action
      teleport="body"
    />
  </div>
</template>

<script setup lang="ts">
import { MateMailType, MemoryType } from "@/enums/mateEnums";
import { Mate, MateMail } from "@/types/entity";
import moment from "moment-timezone";
import { useRouter, useRoute } from "vue-router";
import { useInteractive } from "@/stores/interactive";
import {
  showConfirmDialog,
  showFailToast,
  showLoadingToast,
  showSuccessToast,
} from "vant";
import { computed, onMounted, ref } from "vue";
import { useMate } from "@/stores/mate";
import { useName } from "@/use/common";
import { DispatchType } from "@/enums/mission";
import { useGlobalUser } from "@/stores/globalUser";
import { sessionStorageSet } from "@/tools/sessionStorage";

const props = defineProps<{
  mail: MateMail;
  showDetail?: boolean;
  isChild?: boolean;
  isSelect?: boolean;
  include?: number[];
  tabType?: MateMailType;
}>();

const emit = defineEmits<{
  (e: "reload"): void;
  (e: "select", mail: MateMail): void;
}>();

const mateStore = useMate();
const expanded = ref(true);
const userStore = useGlobalUser();

const type = computed<MateMailType | undefined>(() => {
  const { sender, recipient, dtSend, dtSenderTrash } = props.mail;
  if (!dtSend) return MateMailType.Draft;
  if (dtSenderTrash) return MateMailType.Trashed;

  if (sender) {
    if (
      mateStore.isMyMateById(sender.id) ||
      sender.userId === userStore.user.id
    ) {
      return MateMailType.Sent;
    } else {
      return MateMailType.Inbox;
    }
  }

  if (recipient) {
    if (
      mateStore.isMyMateById(recipient.id) ||
      recipient.userId === userStore.user.id
    ) {
      return MateMailType.Inbox;
    }
    return MateMailType.Sent;
  }

  return undefined;
});

const router = useRouter();
const route = useRoute();
const interactiveStore = useInteractive();
const clickReply = () => {
  if (!props.mail.sender) return showFailToast("该用户状态异常，暂无法回信。");
  router.push({
    name: "mailEdit",
    query: { parentUuid: props.mail.uuid },
  });
};

const clickMate = (mate?: Mate) => {
  if (!mate) return;
  if (props.isSelect) {
    emit("select", props.mail);
    return;
  }
  router.push({
    name: "mateHome",
    params: { uuid: mate.uuid },
  });
};

const clickViewMailList = () => {
  let sourceId = 0;
  let targetId = 0;
  let name = "";

  if (type.value === MateMailType.Inbox) {
    sourceId = props.mail.recipientId;
    targetId = props.mail.senderId;
    name = props.mail.sender?.name ?? "";
  } else {
    sourceId = props.mail.senderId;
    targetId = props.mail.recipientId;
    name = props.mail.recipient?.name ?? "";
  }
  const query = {
    type: MateMailType.Threadbox,
    sourceId,
    targetId,
    targetName: useName(name),
  };
  if (route.name !== "mailList") {
    router.push({
      name: "mailList",
      query,
    });
  } else {
    router.replace({
      query,
    });
  }
};

const clickDelete = () => {
  showConfirmDialog({
    title: "提示",
    message: "确定删除该信件吗？",
  }).then(async () => {
    const loading = showLoadingToast("删除中...");
    await interactiveStore.deleteMail(props.mail.id);
    loading.close();
    showSuccessToast("删除成功");
    emit("reload");
  });
};

const clickMail = () => {
  if (props.isSelect) {
    emit("select", props.mail);
  }
};

const clickInviteTask = () => {
  const { sender, recipient } = props.mail;
  if (!sender || !recipient)
    return showFailToast("该用户状态异常，暂无法邀请任务。");
  const { uuid: senderUuid } = sender;
  const { uuid: recipientUuid } = recipient;
  let hostUuid, inviteeUuid;
  if (mateStore.isMyMate(senderUuid)) {
    hostUuid = senderUuid;
    inviteeUuid = recipientUuid;
  } else {
    hostUuid = recipientUuid;
    inviteeUuid = senderUuid;
  }

  router.push({
    name: "missionEdit",
    query: {
      hostUuid,
      inviteeUuid,
      type: DispatchType.Mission,
    },
  });
};

const showActionSheet = ref(false);

const actions = [
  {
    name: "查看往来信件",
    callback: () => clickViewMailList(),
  },
  {
    name: "邀请任务",
    callback: () => clickInviteTask(),
  },

  {
    name: "删除",
    className: "text-error",
    callback: () => clickDelete(),
  },
  {
    name: "关闭",
    className: "text-base-content/50",
    callback: () => (showActionSheet.value = false),
  },
];

const clickCreateSceneMemory = () => {
  sessionStorageSet("memory:edit:source", {
    mailzz: [props.mail],
  });
  const { sender, recipient } = props.mail;

  let mateId = mateStore.isMyMateById(sender?.id) ? sender?.id : recipient?.id;

  router.push({
    name: "mateMemoryEdit",
    query: {
      type: MemoryType.Scene,
      mateId,
      hasSource: 1,
    },
  });
};

onMounted(() => {
  if (!props.isChild) {
    const { children, sender, recipient } = props.mail;

    const mateIdMap = new Map<number, Mate>();
    if (sender) mateIdMap.set(sender.id, sender);
    if (recipient) mateIdMap.set(recipient.id, recipient);

    for (const child of children) {
      child.sender = mateIdMap.get(child.senderId);
      child.recipient = mateIdMap.get(child.recipientId);
    }
  }

  if (props.isSelect) {
    expanded.value = false;
  }
});
</script>
